/** Routes for documentation. */
export const docRoute = `/doc`;

export const DocRoutes = {
  /** Documentation home. */
  DOCS: `${docRoute}`,
  /** Documentation API. */
  API: `${docRoute}/api`
};
